var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "product-list-item card",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
          [
            _c(
              "div",
              { staticClass: "product-image-wrapper" },
              [
                _vm._t("item-image", function() {
                  return [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          )
                        }
                      },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "picture-class": "product-image",
                            "image-url": _vm.categoryVariationImages.urlMiddle,
                            alt: _vm.item.texts.name1,
                            title: _vm.item.texts.name1
                          }
                        })
                      ],
                      1
                    )
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm.isLoadingVariations
              ? _c("div", { staticClass: "thumb-content__loading" }, [
                  _vm._v("Lade...")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.variations && _vm.variations.length > 0
              ? _c(
                  "div",
                  {
                    ref: "thumbSwiperOuter",
                    staticClass:
                      "swiper-outer-container swiper-outer-container-thumb-swiper"
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "thumbSwiper",
                        staticClass:
                          "swiper-container category-item__thumb-swiper"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "swiper-wrapper",
                            class: {
                              "swiper-wrapper__center":
                                _vm.variations && _vm.variations.length < 3
                            }
                          },
                          _vm._l(_vm.variations, function(variation) {
                            return _c("div", { staticClass: "swiper-slide" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm._f("itemURL")(
                                      _vm.item,
                                      _vm.urlWithVariationId
                                    )
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "swiper-lazy",
                                    attrs: {
                                      width: "43",
                                      height: "43",
                                      alt: _vm._f("itemName")(_vm.item),
                                      "data-src": variation.previewImage.url,
                                      image: variation.bigImage.url
                                    },
                                    on: {
                                      mouseover: function($event) {
                                        return _vm.mouseOverThumbImage(
                                          $event.target
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.variations && _vm.variations.length > 3
                      ? _c(
                          "div",
                          { staticClass: "category-item__thumb-swiper-prev" },
                          [_c("i", { staticClass: "fa fa-angle-left" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.variations && _vm.variations.length > 3
                      ? _c(
                          "div",
                          { staticClass: "category-item__thumb-swiper-next" },
                          [_c("i", { staticClass: "fa fa-angle-right" })]
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("store-special", function() {
              return [
                _vm.storeSpecial ||
                _vm.item.variation.bundleType === "bundle" ||
                _vm.item.item.itemType === "set"
                  ? _c("item-store-special", {
                      attrs: {
                        "store-special": _vm.storeSpecial,
                        "recommended-retail-price": _vm.item.prices.rrp,
                        "variation-retail-price": _vm.item.prices.default,
                        "special-offer-price": _vm.item.prices.specialOffer,
                        "decimal-count": _vm.decimalCount,
                        "bundle-type": _vm.item.variation.bundleType,
                        "item-type": _vm.item.item.itemType
                      }
                    })
                  : _vm._e()
              ]
            }),
            _vm._v(" "),
            _vm._t("item-details", function() {
              return [
                _c(
                  "div",
                  { staticClass: "product-info" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "product-name",
                        attrs: {
                          href: _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._f("itemName")(_vm.item))
                        ),
                        _vm._l(_vm.item.groupedAttributes, function(attribute) {
                          return _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Ceres::Template.itemGroupedAttribute",
                                  attribute
                                )
                              )
                            )
                          ])
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._t("before-prices"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "price-buy-wrapper" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "product-price",
                            class: {
                              "product-price--sale":
                                _vm.item.prices.rrp &&
                                _vm.item.prices.rrp.price.value > 0 &&
                                _vm.item.prices.rrp.price.value >
                                  _vm.item.prices.default.unitPrice.value
                            }
                          },
                          [
                            _vm.item.item.itemType === "set"
                              ? [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemSetPrice",
                                          { price: _vm.itemSetPrice }
                                        )
                                      ) +
                                      "*\n                            "
                                  )
                                ]
                              : !!_vm.item.item &&
                                _vm.item.item.salableVariationCount > 1 &&
                                _vm.$ceres.isCheapestSorting
                              ? [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.categoryItemFromPrice",
                                          { price: _vm.itemPrice }
                                        )
                                      ) +
                                      "*\n                            "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm._f("specialOffer")(
                                          _vm.item.prices.default.unitPrice
                                            .formatted,
                                          _vm.item.prices,
                                          "unitPrice",
                                          "formatted"
                                        )
                                      ) +
                                      "*\n                            "
                                  )
                                ],
                            _vm._v(" "),
                            _vm.item.prices.rrp &&
                            _vm.item.prices.rrp.price.value > 0 &&
                            _vm.item.prices.rrp.price.value >
                              _vm.item.prices.default.unitPrice.value
                              ? [
                                  _vm.item.prices.specialOffer
                                    ? _c(
                                        "span",
                                        { staticClass: "product-price--uvp" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.item.prices.default
                                                  .unitPrice.formatted
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "product-price--uvp" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.item.prices.rrp.unitPrice
                                                  .formatted
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._t("after-prices"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "wishlist-buy" },
                          [
                            _c("category-add-wishlist", {
                              attrs: { "item-id": _vm.item.variation.id }
                            }),
                            _vm._v(" "),
                            _c("add-to-basket", {
                              attrs: {
                                "data-testing": "item-add-to-basket",
                                "variation-id": _vm.item.variation.id,
                                "is-salable":
                                  !!_vm.item.filter &&
                                  _vm.item.filter.isSalable,
                                "has-children":
                                  !!_vm.item.item &&
                                  _vm.item.item.salableVariationCount > 1,
                                "interval-quantity":
                                  _vm.item.variation.intervalOrderQuantity || 1,
                                "minimum-quantity":
                                  _vm.item.variation.minimumOrderQuantity,
                                "maximum-quantity":
                                  !!_vm.item.variation.maximumOrderQuantity &&
                                  _vm.item.variation.maximumOrderQuantity > 0
                                    ? _vm.item.variation.maximumOrderQuantity
                                    : null,
                                "order-properties": _vm.item.properties.filter(
                                  function(prop) {
                                    return prop.property.isOderProperty
                                  }
                                ),
                                "has-order-properties":
                                  _vm.item.hasOrderProperties,
                                "use-large-scale": false,
                                "show-quantity": false,
                                "item-url": _vm._f("itemURL")(
                                  _vm.item,
                                  _vm.urlWithVariationId
                                ),
                                "has-price": _vm._f("hasItemDefaultPrice")(
                                  _vm.item
                                ),
                                "item-type": _vm.item.item.itemType
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  2
                )
              ]
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }